import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';
import ca from './locales/ca.json';
import eu from './locales/eu.json';
import gl from './locales/gl.json';
import pt from './locales/pt.json';
import ptBR from './locales/pt-BR.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import de from './locales/de.json';
import jp from './locales/jp.json';
import zh from './locales/zh.json';

const supportedLanguages = ['en', 'es', 'ca', 'eu', 'gl', 'pt', 'pt-BR', 'fr', 'it', 'de', 'jp', 'zh'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      ca: { translation: ca },
      eu: { translation: eu },
      gl: { translation: gl },
      pt: { translation: pt },
      'pt-BR': { translation: ptBR },
      fr: { translation: fr },
      it: { translation: it },
      de: { translation: de },
      jp: { translation: jp },
      zh: { translation: zh },
    },
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    nonExplicitSupportedLngs: true,
    debug: false,
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      checkWhitelist: true,
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
